import { DiscordButton } from './DiscordButton';

export function LoggedOutHeaderButtons() {
  return (
    <>
      <DiscordButton showInMenu={false} />
    </>
  );
}
